<lifecycle
  onMount() {
    import("web-vitals").then(({ onLCP, onCLS, onINP, onTTFB }) => {
      const send = (metric) => {
        const body = JSON.stringify({
          name: metric.name,
          value: Math.round(metric.value * 1000) / 1000,
          rating: metric.rating,
          path: location.pathname,
        });
        if (navigator.sendBeacon) {
          navigator.sendBeacon("/api/vitals", body);
        } else {
          fetch("/api/vitals", { method: "POST", body, keepalive: true });
        }
      };
      onLCP(send);
      onCLS(send);
      onINP(send);
      onTTFB(send);
    });
  }
/>
